let autoLoad = true

export function setAutoLoad(flag: boolean) {
  autoLoad = flag
}

export function isAutoLoad() {
  return autoLoad
}
